module.exports = __webpack_public_path__ + "img/devices.b4376932.png";